import { Typography } from "@material-tailwind/react";
import FooterBackgroundImage2 from '../../assets/images/Backgrounds/ayurvedic-theme-5.jpg';
import { Link } from 'react-router';
import LINKS from '../../models/FooterNavDataLinks';

const logoData = [
    {
        id: "whatsapp",
        logoPath: "M24 11.7c0 6.45-5.27 11.68-11.78 11.68-2.07 0-4-.53-5.7-1.45L0 24l2.13-6.27a11.57 11.57 0 0 1-1.7-6.04C.44 5.23 5.72 0 12.23 0 18.72 0 24 5.23 24 11.7M12.22 1.85c-5.46 0-9.9 4.41-9.9 9.83 0 2.15.7 4.14 1.88 5.76L2.96 21.1l3.8-1.2a9.9 9.9 0 0 0 5.46 1.62c5.46 0 9.9-4.4 9.9-9.83a9.88 9.88 0 0 0-9.9-9.83m5.95 12.52c-.08-.12-.27-.19-.56-.33-.28-.14-1.7-.84-1.97-.93-.26-.1-.46-.15-.65.14-.2.29-.75.93-.91 1.12-.17.2-.34.22-.63.08-.29-.15-1.22-.45-2.32-1.43a8.64 8.64 0 0 1-1.6-1.98c-.18-.29-.03-.44.12-.58.13-.13.29-.34.43-.5.15-.17.2-.3.29-.48.1-.2.05-.36-.02-.5-.08-.15-.65-1.56-.9-2.13-.24-.58-.48-.48-.64-.48-.17 0-.37-.03-.56-.03-.2 0-.5.08-.77.36-.26.29-1 .98-1 2.4 0 1.4 1.03 2.76 1.17 2.96.14.19 2 3.17 4.93 4.32 2.94 1.15 2.94.77 3.47.72.53-.05 1.7-.7 1.95-1.36.24-.67.24-1.25.17-1.37",
        logoLink: "https://wa.me/94710622696",
    },
    {
        id: "instagram",
        logoPath: "M16.98 0a6.9 6.9 0 0 1 5.08 1.98A6.94 6.94 0 0 1 24 7.02v9.96c0 2.08-.68 3.87-1.98 5.13A7.14 7.14 0 0 1 16.94 24H7.06a7.06 7.06 0 0 1-5.03-1.89A6.96 6.96 0 0 1 0 16.94V7.02C0 2.8 2.8 0 7.02 0h9.96zm.05 2.23H7.06c-1.45 0-2.7.43-3.53 1.25a4.82 4.82 0 0 0-1.3 3.54v9.92c0 1.5.43 2.7 1.3 3.58a5 5 0 0 0 3.53 1.25h9.88a5 5 0 0 0 3.53-1.25 4.73 4.73 0 0 0 1.4-3.54V7.02a5 5 0 0 0-1.3-3.49 4.82 4.82 0 0 0-3.54-1.3zM12 5.76c3.39 0 6.2 2.8 6.2 6.2a6.2 6.2 0 0 1-12.4 0 6.2 6.2 0 0 1 6.2-6.2zm0 2.22a3.99 3.99 0 0 0-3.97 3.97A3.99 3.99 0 0 0 12 15.92a3.99 3.99 0 0 0 3.97-3.97A3.99 3.99 0 0 0 12 7.98zm6.44-3.77a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8z",
        logoLink: "https://www.instagram.com/ceylonhospital_wellness",

    },
    {
        id: "facebook",
        logoPath: "M24 12.07C24 5.41 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.04V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.5c-1.5 0-1.96.93-1.96 1.89v2.26h3.32l-.53 3.5h-2.8V24C19.62 23.1 24 18.1 24 12.07",
        logoLink: "https://www.facebook.com/p/Ceylon-Hospital-Wellness-61555704856772",

    },
    {
        id: "youtube",
        logoPath: "M12.04 3.5c.59 0 7.54.02 9.34.5a3.02 3.02 0 0 1 2.12 2.15C24 8.05 24 12 24 12v.04c0 .43-.03 4.03-.5 5.8A3.02 3.02 0 0 1 21.38 20c-1.76.48-8.45.5-9.3.51h-.17c-.85 0-7.54-.03-9.29-.5A3.02 3.02 0 0 1 .5 17.84c-.42-1.61-.49-4.7-.5-5.6v-.5c.01-.9.08-3.99.5-5.6a3.02 3.02 0 0 1 2.12-2.14c1.8-.49 8.75-.51 9.34-.51zM9.54 8.4v7.18L15.82 12 9.54 8.41z",
        logoLink: "https://www.youtube.com/@CeylonHospitalWellness",
    },
    {
        id: "tiktok",
        logoPath: "M20 0c2.2091 0 4 1.7909 4 4v16c0 2.2091-1.7909 4-4 4H4c-2.2091 0-4-1.7909-4-4V4c0-2.2091 1.7909-4 4-4Zm-4.8377 4h-2.7508v10.9209a2.3324 2.3324 0 0 1-3.0455 2.2209 2.3324 2.3324 0 0 1 1.4129-4.4459V9.8862a5.0812 5.0812 0 0 0-5.7481 5.5912 5.0805 5.0805 0 0 0 3.802 4.3668 5.0818 5.0818 0 0 0 5.423-2.0286c.5899-.8501.9062-1.86.9065-2.8947V9.3345A6.5666 6.5666 0 0 0 19 10.5614V7.83a3.796 3.796 0 0 1-2.0944-.6295 3.8188 3.8188 0 0 1-1.6852-2.5075 3.7856 3.7856 0 0 1-.058-.693Z",
        logoLink: "https://www.tiktok.com/@ceylonhospital",
    },
]

const Footer = () => {


    return (
        <>
            <footer
                className="relative w-full pt-10"
                style={{
                    backgroundImage: `url(${FooterBackgroundImage2})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-20 z-1" />

                <div className="mx-auto w-full max-w-7xl px-8">
                    <div className="grid grid-cols-1 md:grid-cols-2">
                        <div className="mb-5 gap-5 z-10">
                            <Typography variant="h4" className="opacity-80 text-white nav_logo_AlegreyaSans-Light">
                                Ceylon Hospital Wellness
                            </Typography>

                            <div className="lg:ml-6 ml-0">

                                <div className="flex gap-3 my-2 opacity-80 transition-opacity hover:opacity-100">
                                    <Typography className="p-1 flex items-center">
                                        <svg className="h-5 w-5" fill="white" viewBox="0 0 24 24" aria-hidden="true">
                                            <path
                                                fillRule="evenodd"
                                                d="M12 2a7 7 0 00-7 7c0 5.25 7 12 7 12s7-6.75 7-12a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </Typography>
                                    <a href="https://maps.app.goo.gl/jobze8ygpAjhFLQx6"
                                        target="_blank">
                                        <Typography
                                            className="p-1 font-normal text-white text_OpenSans-VariableFont_wdth"
                                        >
                                            42/27/1/B, Ruksewana, Gemunupura, Yakkala 11870,
                                            <br />
                                            Gampaha, Sri Lanka
                                        </Typography>
                                    </a>
                                </div>
                                <div className="flex gap-3 my-2 opacity-80 transition-opacity hover:opacity-100">
                                    <Typography className="p-1 flex items-center">
                                        <svg className="h-5 w-5" fill="white" viewBox="0 0 24 24" aria-hidden="true">
                                            <path
                                                fillRule="evenodd"
                                                d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 01.91-.27c.98.22 2.02.34 3.08.34a1 1 0 011 1v3.5a1 1 0 01-1.11 1 19.835 19.835 0 01-8.8-3.33 19.842 19.842 0 01-6.47-6.47A19.835 19.835 0 013.62 4.11 1 1 0 014.62 3h3.5a1 1 0 011 1c0 1.06.12 2.1.34 3.08a1 1 0 01-.27.91l-2.2 2.2z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </Typography>
                                    <a href="tel:+94710622696">
                                        <Typography
                                            className="p-1 font-normal text-white text_OpenSans-VariableFont_wdth"
                                        >
                                            +94 710 622 696
                                        </Typography>
                                    </a>
                                </div>
                                <div className="flex gap-3 my-2 opacity-80 transition-opacity hover:opacity-100">
                                    <Typography className="p-1 flex items-center">
                                        <svg className="h-5 w-5" fill="white" viewBox="0 0 24 24" aria-hidden="true">
                                            <path
                                                d="M1.5 6A1.5 1.5 0 013 4.5h18A1.5 1.5 0 0122.5 6v12A1.5 1.5 0 0121 19.5H3A1.5 1.5 0 011.5 18V6zM3 6v.217l9 5.25 9-5.25V6H3zm0 1.783v10.217h18V7.783l-9 5.25-9-5.25z"
                                            />
                                        </svg>
                                    </Typography>
                                    <a href="mailto:chwellness@ceylonhospital.com">
                                        <Typography
                                            className="p-1 font-normal text-white text_OpenSans-VariableFont_wdth"
                                        >
                                            chwellness@ceylonhospital.com
                                        </Typography>
                                    </a>
                                </div>
                            </div>

                            {/* <div className="justify-self-center ml-5 w-5/12 md:w-48">
                                <img
                                    src={FooterImage}
                                    alt="Footer image"
                                    className="h-auto rounded-md"
                                />
                            </div> */}
                        </div>

                        <div className="grid grid-cols-3 justify-between gap-4 z-10">
                            {LINKS.map(({ title, items }) => (
                                <ul key={title}>
                                    <Typography
                                        variant="h5"
                                        color="white"
                                        className="mb-3 font-bold opacity-100 text-customBeige-55 "
                                    >
                                        {title}
                                    </Typography>
                                    {items.map(({ label, href }) => (
                                        <li key={label}>
                                            <Typography
                                                className="py-1.5 font-extralight text-white"
                                            >
                                                <Link to={href} className="transition-colors hover:text-customBeige-55 duration-300 text_OpenSans-VariableFont_wdth">
                                                    {label}
                                                </Link>
                                            </Typography>
                                        </li>
                                    ))}
                                </ul>
                            ))}
                        </div>
                    </div>

                    <div className="mt-2  py-4 flex w-full flex-col items-center justify-center border-t border-blue-gray-50 md:flex-row md:justify-between">
                        <Typography
                            variant="small"
                            className="mb-4 text-center font-normal md:mb-0 text-gray-300 text_OpenSans-VariableFont_wdth"
                        >
                            &copy; 2023 <a href="#">Alpha Management Group(PVT)Ltd.</a> All
                            Rights Reserved.
                        </Typography>

                        <div className="pt-3 flex gap-4 sm:justify-center">


                            {logoData.map((logoItem) => (

                                <Typography
                                    key={logoItem.id}
                                    as="a"
                                    href={logoItem.logoLink}
                                    target="_blank"
                                    className="opacity-80 transition-all duration-300 hover:opacity-100 text-black hover:text-white"
                                >
                                    <svg
                                        className="h-6 w-6"
                                        fill="currentColor"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d={logoItem.logoPath}
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </Typography>

                            ))}

                        </div>
                    </div>
                </div>
            </footer >
        </>
    );
}
export default Footer